/* MIRALIVIA — product page */
(function () {
  'use strict';

  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  /* Los seis marcadores que usa Shopify, no tres. Con los que faltaban, un
     formato como amount_no_decimals_with_comma_separator no casaba con ninguna
     expresion y el precio se pintaba LITERALMENTE como "{{amount_...}}" en
     cuanto se cambiaba de talla. Se ordenan de mas largo a mas corto porque
     'amount' es prefijo de todos los demas. */
  function money(cents, format) {
    const n = cents / 100;
    const dec = n.toFixed(2);
    const int = Math.round(n).toString();
    function group(s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
    const parts = dec.split('.');

    const table = [
      ['amount_no_decimals_with_comma_separator', group(int, '.')],
      ['amount_no_decimals_with_space_separator', group(int, ' ')],
      ['amount_with_apostrophe_separator', group(parts[0], "'") + '.' + parts[1]],
      ['amount_with_comma_separator', group(parts[0], '.') + ',' + parts[1]],
      ['amount_with_space_separator', group(parts[0], ' ') + ',' + parts[1]],
      ['amount_no_decimals', group(int, ',')],
      ['amount', group(parts[0], ',') + '.' + parts[1]]
    ];

    /* Sin formato no se inventa un simbolo: '$' fijo era una mentira en una
       tienda canadiense y peor aun en un segundo mercado. */
    if (!format) return table[6][1];

    for (let i = 0; i < table.length; i++) {
      const re = new RegExp('\\{\\{\\s*' + table[i][0] + '\\s*\\}\\}');
      if (re.test(format)) return format.replace(re, table[i][1]);
    }
    return format;
  }

  /* =========================================================
     GALLERY
     ========================================================= */
  $$('[data-gallery]').forEach(function (gallery) {
    const slidesWrap = $('[data-gallery-slides]', gallery);
    const slides = $$('[data-gallery-slide]', gallery);
    const thumbs = $$('[data-gallery-thumb]', gallery);
    const counter = $('[data-gallery-counter]', gallery);
    if (!slidesWrap || !slides.length) return;

    function activeIndex() {
      const w = slidesWrap.clientWidth || 1;
      return Math.round(slidesWrap.scrollLeft / w);
    }

    function sync() {
      const i = activeIndex();
      thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
      if (counter) counter.textContent = i + 1 + ' / ' + slides.length;
    }

    function goTo(i, smooth) {
      const idx = Math.max(0, Math.min(slides.length - 1, i));
      slidesWrap.scrollTo({ left: idx * slidesWrap.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    gallery._goTo = goTo;

    slidesWrap.addEventListener('scroll', function () {
      window.clearTimeout(slidesWrap._t);
      slidesWrap._t = window.setTimeout(sync, 60);
    }, { passive: true });

    thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));
    const prev = $('[data-gallery-prev]', gallery);
    const next = $('[data-gallery-next]', gallery);
    if (prev) prev.addEventListener('click', () => goTo(activeIndex() - 1));
    if (next) next.addEventListener('click', () => goTo(activeIndex() + 1));
    sync();

    /* --------- Lightbox --------- */
    const lightbox = $('[data-lightbox]');
    if (lightbox) {
      const stage = $('[data-lightbox-stage]', lightbox);
      const lbThumbs = $$('[data-lightbox-thumb]', lightbox);
      let current = 0;

      function show(i) {
        current = Math.max(0, Math.min(lbThumbs.length - 1, i));
        const src = lbThumbs[current].dataset.full;
        const img = $('img', stage);
        if (lightbox._resetZoom) lightbox._resetZoom();
        else img.classList.remove('is-zoomed');
        img.src = src;
        img.alt = lbThumbs[current].alt || '';
        lbThumbs.forEach((t, n) => t.classList.toggle('is-active', n === current));
      }
      lightbox._show = show;

      function open(i) {
        show(i);
        lightbox.classList.add('is-open');
        /* El bloqueo compartido de theme.js lleva un CONTADOR de capas
           abiertas. Tocando la clase a mano, cerrar el visor con el cajon del
           carrito abierto liberaba el scroll aunque el cajon siguiera puesto, y
           la pagina se desplazaba por detras. */
        if (window.MLlock) window.MLlock(); else document.body.classList.add('no-scroll');
      }
      function close() {
        lightbox.classList.remove('is-open');
        if (window.MLunlock) window.MLunlock(); else document.body.classList.remove('no-scroll');
      }

      slides.forEach((s, i) => {
        const img = $('img', s);
        if (img) img.addEventListener('click', () => open(i));
      });
      const hint = $('[data-gallery-zoom]', gallery);
      if (hint) hint.addEventListener('click', () => open(activeIndex()));

      lbThumbs.forEach((t, i) => t.addEventListener('click', () => show(i)));
      $$('[data-lightbox-close]', lightbox).forEach((b) => b.addEventListener('click', close));
      const lbPrev = $('[data-lightbox-prev]', lightbox);
      const lbNext = $('[data-lightbox-next]', lightbox);
      if (lbPrev) lbPrev.addEventListener('click', () => show(current - 1));
      if (lbNext) lbNext.addEventListener('click', () => show(current + 1));

      /* --------- Zoom con arrastre ---------
         Ampliar con transform: scale() no cambia la caja de diseno, asi que
         el contenedor no tenia nada que desplazar y la mitad de arriba de la
         foto quedaba fuera de alcance. Aqui la imagen se mueve con un
         translate propio, limitado para que no se pueda sacar de la pantalla.

         El translate va dentro del scale, asi que se divide por el factor
         para que un pixel arrastrado sea un pixel movido. */
      const stageImg = $('img', stage);
      if (stageImg) {
        const SCALE = 2;
        let zx = 0, zy = 0;
        let panning = false, startX = 0, startY = 0, travelled = 0;

        function apply() {
          if (!stageImg.classList.contains('is-zoomed')) {
            stageImg.style.transform = '';
            return;
          }
          stageImg.style.transform =
            'scale(' + SCALE + ') translate(' + (zx / SCALE) + 'px, ' + (zy / SCALE) + 'px)';
        }

        function clampPan() {
          /* offsetWidth es el tamano de diseno, que el transform no altera:
             sirve de base fiable para saber cuanto sobra por cada lado. */
          const box = stage.getBoundingClientRect();
          const maxX = Math.max(0, (stageImg.offsetWidth * SCALE - box.width) / 2);
          const maxY = Math.max(0, (stageImg.offsetHeight * SCALE - box.height) / 2);
          zx = Math.min(maxX, Math.max(-maxX, zx));
          zy = Math.min(maxY, Math.max(-maxY, zy));
        }

        function resetZoom() {
          stageImg.classList.remove('is-zoomed');
          zx = 0; zy = 0;
          apply();
        }
        lightbox._resetZoom = resetZoom;

        stageImg.addEventListener('click', function () {
          if (travelled > 5) { travelled = 0; return; }
          stageImg.classList.toggle('is-zoomed');
          zx = 0; zy = 0;
          apply();
        });

        stageImg.addEventListener('pointerdown', function (e) {
          if (!stageImg.classList.contains('is-zoomed')) return;
          panning = true;
          travelled = 0;
          startX = e.clientX - zx;
          startY = e.clientY - zy;
          stageImg.style.transition = 'none';
          stageImg.setPointerCapture(e.pointerId);
          e.preventDefault();
        });

        stageImg.addEventListener('pointermove', function (e) {
          if (!panning) return;
          const nx = e.clientX - startX;
          const ny = e.clientY - startY;
          travelled = Math.max(travelled, Math.abs(nx - zx) + Math.abs(ny - zy));
          zx = nx; zy = ny;
          clampPan();
          apply();
        });

        function endPan(e) {
          if (!panning) return;
          panning = false;
          stageImg.style.transition = '';
          if (e && e.pointerId !== undefined && stageImg.hasPointerCapture(e.pointerId)) {
            stageImg.releasePointerCapture(e.pointerId);
          }
        }
        stageImg.addEventListener('pointerup', endPan);
        stageImg.addEventListener('pointercancel', endPan);
      }

      document.addEventListener('keydown', function (e) {
        if (!lightbox.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') show(current - 1);
        if (e.key === 'ArrowRight') show(current + 1);
      });
    }
  });

  /* =========================================================
     VARIANT PICKER
     ========================================================= */
  $$('[data-variant-picker]').forEach(function (picker) {
    const sectionId = picker.dataset.section;
    const root = document.getElementById('MainProduct-' + sectionId) || document;
    const dataEl = $('[data-variant-json]', picker);
    if (!dataEl) return;

    const variants = JSON.parse(dataEl.textContent);
    const form = $('[data-product-form]', root);
    const idInput = form ? $('[data-variant-id]', form) : null;
    const priceWrap = $('[data-price-block]', root);
    const atc = $('[data-atc]', root);
    const stockWrap = $('[data-stock-alert]', root);
    const skuEl = $('[data-sku]', root);
    const gallery = $('[data-gallery]', root);
    /* El formato largo lleva el codigo de moneda ("$0.00 CAD"). Se usa el
       mismo que imprimio Liquid, o el precio perderia el codigo en cuanto se
       cambiara de talla. */
    const moneyShort = picker.dataset.moneyFormat || '';
    const moneyLong = picker.dataset.moneyFormatCur || '';
    const moneyFormat = picker.dataset.showCurrency === '1' && moneyLong ? moneyLong : moneyShort;
    const lowThreshold = parseInt(picker.dataset.lowStock || '0', 10);
    const soldOutText = picker.dataset.soldOut || 'Sold out';
    const addText = picker.dataset.addText || 'Add to bag';
    const unavailableText = picker.dataset.unavailable || 'Unavailable';

    function selectedOptions() {
      return $$('[data-option-index]', picker).map(function (group) {
        const checked = $('input:checked', group);
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return opts.every(function (o, i) { return o === null || v.options[i] === o; });
      });
    }

    /* Disable option values that cannot be combined with the current selection */
    function updateAvailability(opts) {
      $$('[data-option-index]', picker).forEach(function (group, gi) {
        $$('input', group).forEach(function (input) {
          const probe = opts.slice();
          probe[gi] = input.value;
          const match = variants.find(function (v) {
            return probe.every(function (o, i) { return o === null || v.options[i] === o; });
          });
          input.disabled = !match || !match.available;
        });
      });
    }

    /* Por nodos y con textContent, no concatenando HTML. El formato de moneda
       lo escribe quien tenga permiso de Ajustes, que no es necesariamente
       quien puede tocar el tema: metiendolo en innerHTML, ese rol acababa
       ejecutando JavaScript en la tienda al primer cambio de talla. */
    function priceSpan(cls, text) {
      const s = document.createElement('span');
      s.className = cls;
      s.textContent = text;
      return s;
    }

    function updatePrice(v) {
      if (!priceWrap) return;
      priceWrap.replaceChildren();
      if (!v) return;
      if (v.compare_at_price && v.compare_at_price > v.price) {
        const save = v.compare_at_price - v.price;
        const pct = Math.round((save / v.compare_at_price) * 100);
        priceWrap.append(
          priceSpan('price__sale', money(v.price, moneyFormat)),
          priceSpan('price__compare', money(v.compare_at_price, moneyFormat)),
          priceSpan('price__save', 'Save ' + money(save, moneyFormat) + ' (' + pct + '%)')
        );
      } else {
        priceWrap.append(priceSpan('price__regular', money(v.price, moneyFormat)));
      }
    }

    function updateStock(v) {
      if (!stockWrap) return;
      if (!v || !v.available) { stockWrap.hidden = true; return; }

      const mode = stockWrap.dataset.mode || 'generic';
      const showOn = stockWrap.dataset.showOn || 'all';
      const tagOk = stockWrap.dataset.tagOk === 'true';
      const textEl = $('[data-stock-text]', stockWrap);

      let eligible = false;
      if (showOn === 'all') eligible = true;
      else if (showOn === 'sale') eligible = v.compare_at_price > v.price;
      else if (showOn === 'tag') eligible = tagOk;
      if (!eligible) { stockWrap.hidden = true; return; }

      /* El numero fijo lo calcula Liquid a partir del producto, asi que aqui
         solo se decide si se ve. Tocar el texto lo haria cambiar al elegir otra
         talla, que es justo lo que no debe pasar: tiene que ser el mismo numero
         en cada visita y en cada recarga. */
      if (mode === 'scarcity') { stockWrap.hidden = false; return; }

      if (mode === 'count') {
        const qty = v.inventory_quantity;
        const tracked = v.inventory_management === 'shopify';
        if (tracked && lowThreshold > 0 && qty > 0 && qty <= lowThreshold) {
          const tpl = stockWrap.dataset.template || 'Only [count] left in stock';
          if (textEl) textEl.textContent = tpl.replaceAll('[count]', qty);
          stockWrap.hidden = false;
        } else {
          stockWrap.hidden = true;
        }
        return;
      }

      if (textEl) textEl.textContent = stockWrap.dataset.generic || '';
      stockWrap.hidden = false;
    }

    function updateButton(v) {
      if (!atc) return;
      const label = $('[data-atc-text]', atc) || atc;
      if (!v) { atc.setAttribute('aria-disabled', 'true'); atc.disabled = true; label.textContent = unavailableText; return; }
      if (!v.available) { atc.setAttribute('aria-disabled', 'true'); atc.disabled = true; label.textContent = soldOutText; return; }
      atc.removeAttribute('aria-disabled'); atc.disabled = false; label.textContent = addText;
    }

    function updateMedia(v) {
      if (!gallery || !v || v.featured_media_index === null || v.featured_media_index === undefined) return;
      if (gallery._goTo) gallery._goTo(v.featured_media_index);
      const lightbox = $('[data-lightbox]');
      if (lightbox && lightbox._show && lightbox.classList.contains('is-open')) lightbox._show(v.featured_media_index);
    }

    function updateUrl(v) {
      if (!v || !window.history.replaceState) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    function onChange() {
      const opts = selectedOptions();
      updateAvailability(opts);
      const v = findVariant(opts);

      $$('[data-option-index]', picker).forEach(function (group) {
        const out = $('[data-selected-value]', group);
        const checked = $('input:checked', group);
        if (out && checked) out.textContent = checked.value;
      });

      if (idInput) idInput.value = v ? v.id : '';
      if (skuEl) skuEl.textContent = v && v.sku ? v.sku : '';
      updatePrice(v);
      updateStock(v);
      updateButton(v);
      updateMedia(v);
      updateUrl(v);
      document.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant: v } }));
    }

    picker.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"]')) onChange();
    });

    onChange();
  });

  /* =========================================================
     STICKY ADD TO CART (mobile)
     ========================================================= */
  const sticky = $('[data-sticky-atc]');
  const anchor = $('[data-atc-anchor]');
  const footer = document.querySelector('.footer');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    /* Dos condiciones, no una: la barra sale cuando el bloque de compra ya ha
       pasado por arriba, PERO se esconde en cuanto asoma el footer. Sin lo
       segundo se quedaba fija encima de los enlaces del footer y habia que
       adivinar donde pulsar. Como la barra vive pegada al fondo de la ventana,
       el momento en que el footer empieza a entrar es justo cuando el footer
       ocupa esa franja, asi que basta con isIntersecting por defecto. */
    let pastBuyBlock = false;
    let footerInView = false;
    const sync = function () {
      sticky.classList.toggle('is-visible', pastBuyBlock && !footerInView);
    };

    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          pastBuyBlock = !en.isIntersecting && en.boundingClientRect.top < 0;
        });
        sync();
      },
      { threshold: 0 }
    ).observe(anchor);

    if (footer) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) { footerInView = en.isIntersecting; });
          sync();
        },
        { threshold: 0 }
      ).observe(footer);
    }
    const stickyBtn = $('[data-sticky-atc-btn]', sticky);
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        const form = $('[data-product-form]');
        if (!form) return;
        /* El boton fijo solo aparece cuando el bloque de compra ya se ha
           scrolleado, asi que el mensaje de error del formulario queda fuera de
           pantalla: al tocarlo sobre una talla agotada no pasaba NADA visible.
           Se le pasa el propio boton para que sea el quien de el feedback. */
        window.MLaddToCart(form, stickyBtn);
      });
    }
  }
})();

/* ---------- Collapsible description ----------
   Only shows the toggle when the text is actually taller than the clamp, so
   short descriptions never get a pointless "View more" button. */
(function () {
  function setup(scope) {
    (scope || document).querySelectorAll('[data-desc]').forEach(function (wrap) {
      const body = wrap.querySelector('[data-desc-body]');
      const btn = wrap.querySelector('[data-desc-toggle]');
      const label = wrap.querySelector('[data-desc-label]');
      if (!body || !btn || btn.dataset.ready) return;

      const max = parseInt(getComputedStyle(body).getPropertyValue('--desc-max'), 10) || 240;
      if (body.scrollHeight <= max + 20) {
        body.removeAttribute('data-collapsed');
        btn.hidden = true;
        btn.dataset.ready = '1';
        return;
      }

      btn.dataset.ready = '1';
      btn.addEventListener('click', function () {
        const collapsed = body.getAttribute('data-collapsed') === 'true';
        if (collapsed) {
          body.removeAttribute('data-collapsed');
          btn.setAttribute('aria-expanded', 'true');
          if (label) label.textContent = btn.dataset.less || 'View less';
        } else {
          body.setAttribute('data-collapsed', 'true');
          btn.setAttribute('aria-expanded', 'false');
          if (label) label.textContent = btn.dataset.more || 'View more';
          const top = wrap.getBoundingClientRect().top + window.scrollY - 120;
          if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    });
  }
  if (document.readyState !== 'loading') setup(); else document.addEventListener('DOMContentLoaded', function () { setup(); });
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
})();
